export default {
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  DONE: "done",
  OVERDUE: "overdue",
  CANCELLED: "cancelled"
};
